<template>
  <AddressPage path="zone" v-slot="{ data }">
    <div class="font-bold text-5xl" v-if="data.zone">
      <p class="mb-4">{{ data.zone.zone2023.displayName }}</p>
      <p class="text-2xl text-stone-500 font-normal">2012 Zone {{ data.zone.zone2012.displayName }}</p>
    </div>
  </AddressPage>
</template>
